(function () {
  'use strict';

  function initFcl(section) {
    if (section.dataset.fclInit === '1') return;

    var track = section.querySelector('[data-fcl-track]');
    if (!track) return;

    var prev = section.querySelector('[data-fcl-prev]');
    var next = section.querySelector('[data-fcl-next]');
    var nav = section.querySelector('[data-fcl-nav]');
    if (!prev || !next) return;

    section.dataset.fclInit = '1';

    function pageSize() {
      var firstCard = track.querySelector('.pcl-card');
      if (!firstCard) return track.clientWidth;
      var style = getComputedStyle(track);
      var gap = parseInt(style.columnGap || style.gap || '16', 10) || 16;
      return firstCard.getBoundingClientRect().width + gap;
    }

    function updateNavState() {
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      prev.disabled = atStart;
      next.disabled = atEnd;
      /* Hide nav entirely if track doesn't overflow */
      if (track.scrollWidth <= track.clientWidth + 4) {
        if (nav) nav.style.visibility = 'hidden';
      } else {
        if (nav) nav.style.visibility = 'visible';
        if (nav) nav.setAttribute('aria-hidden', 'false');
      }
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -pageSize() * 2, behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: pageSize() * 2, behavior: 'smooth' });
    });
    track.addEventListener('scroll', updateNavState, { passive: true });
    window.addEventListener('resize', updateNavState, { passive: true });

    /* Ajax add-to-cart — guarded against double-init AND concurrent submits */
    section.querySelectorAll('.pcl-card__form').forEach(function (form) {
      if (form.dataset.fclFormInit === '1') return;
      form.dataset.fclFormInit = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (form.dataset.fclSubmitting === '1') return;
        form.dataset.fclSubmitting = '1';
        var btn = form.querySelector('.pcl-card__add');
        if (btn) btn.disabled = true;
        var data = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: data
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          })
          .catch(function () {})
          .then(function () {
            if (btn) btn.disabled = false;
            delete form.dataset.fclSubmitting;
          });
      });
    });

    updateNavState();
  }

  document.querySelectorAll('.fcl').forEach(initFcl);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('.fcl')) {
      e.target.querySelectorAll('.fcl').forEach(initFcl);
    }
  });
})();
